import i18n from 'i18n';
import { CompositeSettingStatus, ScreenDisplayType } from './ChannelGroup';
import { ChannelGroupSetting } from './ChannelGroupSettings';

/**
 * ECOPD-5722：連台素材的畫面判斷都從 `creativeType`（= bannerTypeId）出發 —— 素材列表的
 * 每一列、素材類型下拉的每一個選項，手上有的都只有它。
 *
 * 查不到渠道就回 undefined 而不是 throw：這條鏈跑在列表的每一列上，一筆對不到渠道的素材
 * 不該炸掉整張列表。
 */
const findSplicedChannelGroupSetting = (creativeType?: number) => {
  const channelGroupId =
    ChannelGroupSetting.findChannelGroupIdByCreativeType(creativeType);
  if (channelGroupId === undefined) {
    return undefined;
  }
  const channelGroupSetting = ChannelGroupSetting.findById(channelGroupId);
  if (!channelGroupSetting) {
    return undefined;
  }
  return channelGroupSetting.getScreenDisplayTypeByCreativeType(
    creativeType!
  ) === ScreenDisplayType.MULTI_SPLICED
    ? channelGroupSetting
    : undefined;
};

/**
 * ECOPD-5722：連台素材所屬渠道的合成設定不可用時，素材的建立 / 編輯 / 複製入口都要擋，
 * 而且要講出原因。
 *
 * 判準是後端算好的 `compositeSettingStatus`，這裡只照讀。前端用 composite 與 screenPixel
 * 重算就會出現第二份定義，症狀是畫面放行、後端回 400077。
 */
export const isCompositeSettingBlocked = (creativeType?: number): boolean => {
  const channelGroupSetting = findSplicedChannelGroupSetting(creativeType);
  if (!channelGroupSetting) {
    return false;
  }
  // 連台素材而渠道沒有這個欄位，代表 RMax 還沒同步過合成設定，一樣不給動。
  return (
    channelGroupSetting.config.screenProperty?.compositeSettingStatus !==
    CompositeSettingStatus.VALID
  );
};

/** 素材側四個入口與後端 400077 共用同一句，措辭指向系統管理員而不是操作人員。 */
export const getCompositeSettingInvalidHint = (): string =>
  i18n.t('creative.compositeSetting.invalidHint');
